/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Note {
    angular.module("meevo.plugins.note", []);
}